import React from 'react';
import { Link } from 'react-router-dom';
export function Logo() {
  return <Link to="/" className="flex items-center py-1" data-id="element-101">
      <img src="https://drwzpk38qkpfb.cloudfront.net/www.magnusoft.com/uploaded/images/software-web-design-development/Magnus-Software-Inc.png" alt="Magnus Software" className="block h-14 w-auto" data-id="element-102" />
    </Link>;
}